// extracted by mini-css-extract-plugin
export default {"container":"CheckAllButton__container-g4eEF","containerRtl":"CheckAllButton__containerRtl-x7TNA","input":"CheckAllButton__input-Lrzna","label":"CheckAllButton__label-s7FgT"};